/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SubjectUrnTypeEnum = "Email" | "Integration" | "Org" | "Person" | "Phone" | "Services" | "Team" | "User" | "%future added value";
export type TimeSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type AddOrgTagsMutationInput = {
    calendarId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
    debuggingReason?: string | null | undefined;
    eventParentRelayId: string;
    moveRangeV3?: MoveRangeInLocalTimeV3Input | null | undefined;
    orgRelayId: string;
    tags?: Array<TagInput> | null | undefined;
};
export type MoveRangeInLocalTimeV3Input = {
    allowedEndTimeInclusive?: DayOffsetTimeSlotInput | null | undefined;
    allowedStartTimeInclusive?: DayOffsetTimeSlotInput | null | undefined;
};
export type DayOffsetTimeSlotInput = {
    dayOffset: number;
    timeSlot: TimeSlot;
};
export type TagInput = {
    name: string;
    value?: string | null | undefined;
};
export type AddUserTagsMutationVariables = {
    input: AddOrgTagsMutationInput;
};
export type AddUserTagsMutationResponse = {
    readonly addOrgTags: {
        readonly eventParent: {
            readonly events: ReadonlyArray<{
                readonly annotatedEvent: {
                    readonly id: string;
                    readonly externalEventId: string | null;
                    readonly userTags: ReadonlyArray<{
                        readonly tag: string;
                        readonly states: ReadonlyArray<{
                            readonly value: string | null;
                            readonly subjectType: SubjectUrnTypeEnum;
                            readonly subjectValue: string;
                            readonly lastModified: number;
                            readonly active: boolean;
                        }> | null;
                    }> | null;
                } | null;
                readonly annotatedRecurringEvent: {
                    readonly id: string;
                    readonly externalEventId: string | null;
                    readonly userTags: ReadonlyArray<{
                        readonly tag: string;
                        readonly states: ReadonlyArray<{
                            readonly value: string | null;
                            readonly subjectType: SubjectUrnTypeEnum;
                            readonly subjectValue: string;
                            readonly lastModified: number;
                            readonly active: boolean;
                        }> | null;
                    }> | null;
                } | null;
            }>;
        } | null;
    } | null;
};
export type AddUserTagsMutation = {
    readonly response: AddUserTagsMutationResponse;
    readonly variables: AddUserTagsMutationVariables;
};



/*
mutation AddUserTagsMutation(
  $input: AddOrgTagsMutationInput!
) {
  addOrgTags(input: $input) {
    eventParent {
      events {
        annotatedEvent {
          id
          externalEventId
          userTags {
            tag
            states {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
        }
        annotatedRecurringEvent {
          id
          externalEventId
          userTags {
            tag
            states {
              value
              subjectType
              subjectValue
              lastModified
              active
            }
          }
        }
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = [
        (v2 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalEventId",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "UserTag",
            "kind": "LinkedField",
            "name": "userTags",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tag",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "TagState",
                    "kind": "LinkedField",
                    "name": "states",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subjectType",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subjectValue",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastModified",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "active",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ], v4 = {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "events",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "AnnotatedEvent",
                "kind": "LinkedField",
                "name": "annotatedEvent",
                "plural": false,
                "selections": (v3 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "AnnotatedEvent",
                "kind": "LinkedField",
                "name": "annotatedRecurringEvent",
                "plural": false,
                "selections": (v3 /*: any*/),
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "AddUserTagsMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "AddOrgTagsMutationPayload",
                    "kind": "LinkedField",
                    "name": "addOrgTags",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventParent",
                            "kind": "LinkedField",
                            "name": "eventParent",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "AddUserTagsMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "AddOrgTagsMutationPayload",
                    "kind": "LinkedField",
                    "name": "addOrgTags",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventParent",
                            "kind": "LinkedField",
                            "name": "eventParent",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                (v2 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "6c2dfdf86762d6336d08cf7a7c7859ca",
            "id": null,
            "metadata": {},
            "name": "AddUserTagsMutation",
            "operationKind": "mutation",
            "text": "mutation AddUserTagsMutation(\n  $input: AddOrgTagsMutationInput!\n) {\n  addOrgTags(input: $input) {\n    eventParent {\n      events {\n        annotatedEvent {\n          id\n          externalEventId\n          userTags {\n            tag\n            states {\n              value\n              subjectType\n              subjectValue\n              lastModified\n              active\n            }\n          }\n        }\n        annotatedRecurringEvent {\n          id\n          externalEventId\n          userTags {\n            tag\n            states {\n              value\n              subjectType\n              subjectValue\n              lastModified\n              active\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '0bbd59f1f262804f550060c79e64ac2e';
export default node;
